import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef, HostListener } from "@angular/core";
import { TabEnum, TabNames } from "./patient.constants";
import { PatientService, CommonService, MorePatientInfoService, AlertService, ControlFileService, NotesLogService, ModalWrapperService } from "src/app/services";
import { PatientStore } from "src/app/store";
import { PatientInfo, SystemData, MorePatientInfo, PatFacility, PatDiagnosis, PatAuditLog, PaginationModel } from "src/app/models";
import { Observable, Subject, forkJoin } from "rxjs";
import { PatientInfoUtil } from "src/app/utils/patient-info.util";
import { FormGroup, FormBuilder } from "@angular/forms";
import { CommonUtil, CreateNPatchFG, NewAuditUtils, NRxUtils } from "src/app/utils";
import { MsgConfig } from "src/app";
import * as moment from "moment";
import { EligibilityComponent } from "../shared";
import { DateCheckUtil } from "src/app/utils/date-checks.util";
import { takeUntil } from "rxjs/operators";
import { v4 as uuid } from 'uuid';
import { HubService } from "src/app/services/Hub.service";
import { PFacilityInfoComponent } from "./facility-info/facility-info.component";
const FAR_FUTURE_DATE = moment("9999-12-31");

@Component({
    selector: "app-patient",
    templateUrl: "./patient.component.html",
    standalone: false
})
export class PatientComponent implements OnInit {
    @Input() patientID: any;
    @Input() FrmFamily: boolean;
    @Input() FrmErx: boolean;
    @Input() defERxPatInfo: any;
    @Input() addPatientModel: FormGroup;
    @Input() isFromDashboard : boolean;
    @Input() erxData: any;

    @Output() ClosePatientModal = new EventEmitter<any>();

    @ViewChild("UNIQUEINSURNUMBER", { static: true }) UNIQUEINSURNUMBER: any;

    @ViewChild("warning", { static: true }) warning: any;

    @ViewChild("PATALGER", { static: true }) PATALGER: any;
    @ViewChild(PFacilityInfoComponent, { static: false }) facilityInfoComp: PFacilityInfoComponent;


    patientInfo$: Observable<PatientInfo>;
    systemData$: Observable<SystemData>;
    patientInfoFG: FormGroup;
    patientInsuList$: Observable<any>;
    facilityInfo$: Observable<any>;
    insuranceData$: any;
    morePatInfo: any;
    morePatFG: FormGroup;
    patFacilityInfo: any;
    patFacilityFG: FormGroup;
    patFacilityFGs: FormGroup[] = [];
    originalPatInfo: any;
    diagList: any;
    openModal: any;
    focusField: any;
    editInsuranceData: any = null;

    currTab: string = "PATIENTINFO";
    tabEnum: any;
    headerEnum: any;
    formGroupInvalid: boolean;
    popUpType: any;
    selectedTab: any;
    addFrmTab: boolean;
    originalMorePatInfo: any;
    OriginalpatFacilityInfo: any;
    resetToFirst = false;
    preferredContact: any;
    addToEditPat: boolean;
    addFromEligibility: boolean;
    resp1: any;
    originalAdmitDt: any;
    maxDate: any;
    minDate: any;
    today: any;
    isNavigateFromPatientInfoTab : boolean = false;
    isNavigateFromPatTabForRefresh : boolean = false;
    isFromEditRx: boolean;
    editedRxPrescReFillId: any;
    Phones: any;
    patientDetailsUpdates: boolean;
    unsubscribe$: Subject<void> = new Subject();
    paginationModel: PaginationModel = new PaginationModel();
    pageNumber = this.paginationModel.pageNumber;
    pageSize = this.paginationModel.pageSize;
    isValueChanged: boolean = false;
    isProgrammaticChange: boolean = false;
    patExternHistData: any;
    isDataAddedorUpdated: any;
    verifiedDtTm: any;
    popupId = uuid();

    private extractFacilityRows(data: any): any[] {
        if (!data) {
            return [];
        }
        if (Array.isArray(data["Facilities"])) {
            return data["Facilities"];
        }
        if (Array.isArray(data["PatFacility"])) {
            return data["PatFacility"];
        }
        if (Array.isArray(data["PatFacilities"])) {
            return data["PatFacilities"];
        }
        if (data["PatFacility"]) {
            return [data["PatFacility"]];
        }
        return [];
    }
 @HostListener("window:keydown", ["$event"])
keyEventAlt(event: KeyboardEvent) {
      const topPopup = this._cmnutil.getTopPopup();
      if (topPopup === this.popupId) {
          if (event.which === 27) {
              this.onCancel('cancel');
              event.preventDefault();
          }
        }
    }
    constructor(private _patientService: PatientService, private _patientStore: PatientStore, private _fb: FormBuilder, private _dateChecks: DateCheckUtil,
        private _commonServ: CommonService, private _patUtils: PatientInfoUtil, private _morePatSvc: MorePatientInfoService,  private _alrtServ: AlertService, private _cnpFG: CreateNPatchFG, private _modalSvc: ModalWrapperService, private _auditUtils: NewAuditUtils, private _notesLogSvc: NotesLogService,
         private _nrxUtls: NRxUtils,  private _controlFileSvc: ControlFileService , private _cdr: ChangeDetectorRef, private _cmnutil: CommonUtil, private hubService: HubService) {
        this.tabEnum = TabEnum;
        this.headerEnum = TabNames;
        this.systemData$ = this._commonServ.systemData$;
        this.insuranceData$ = this._commonServ.insuranceData$;
        this.hubService.setPatientComponent(this);
    }


    get Person(): FormGroup {
        return this.patientInfoFG.get("Person") as FormGroup;
    }

    get InsuCards(): FormGroup {
        return this.patientInfoFG.get("InsuCards") as FormGroup;
    }

    ngOnInit() {
        this._cmnutil.open(this.popupId);
        this.IntialDatePatchings();
        this.patientInfoFG = this.addPatientModel ? this.addPatientModel : this._patUtils.generatePatientInfoFG();
        this.morePatFG = this._fb.group(new MorePatientInfo());
        this.patFacilityFG = null;
        this.patFacilityFGs = [];
        this.patientInsuList$ = this._patientStore.patientInsuList$;
        this.getAndPatchPatient();
        this.patientDetailsUpdates = true;
        this.isValueChanged = false;
    }
    IntialDatePatchings() {
        this.today = moment().format("MM/DD/YYYY");
        this.maxDate = {
            year: moment(this.today).year(),
            month: moment(this.today).month() + 1,
            day: moment(this.today).date()
        };
        this.minDate = {
            year: moment(this.today).year(),
            month: moment(this.today).month() + 1,
            day: moment(this.today).date()
        };
    }
    async getAndPatchPatient() {
        await this.getDiagnosis();
        await this.getPatInsurance();
        if (this.patientID) {
            this.getPatinetInfo();
        } else {
            this.getAddPatInfo();
        }
        this.patientInfoFG.markAsPristine();
    }

    async getPatInsurance() {
        this.patientID ? await this._patUtils.getPatientInsurances(this.patientID) : this._patientStore.storePatientInsuranceList([]);
        this.patientInfoFG.controls["Insurances"].markAsPristine();
        this.isValueChanged = false;
    }

    async getDiagnosis() {
        this.diagList = await this._patientService.getDiagnosisFiltered({
            Code: null, Description: null,
            pageNum: this.pageNumber, pageSize: this.pageSize
        }).toPromise();
        this._patientStore.storeDiagList(this.diagList);
    }

    async getPatinetInfo(frmTab?: any, selectTab?:boolean,frmSignalPatientId?:any) {
        if(frmSignalPatientId && this.patientID !== frmSignalPatientId){
            return;
        }
        this.originalPatInfo = await this._patientService.getEditPatientInformation(frmSignalPatientId ? frmSignalPatientId : this.patientID).toPromise();
        if (this.originalPatInfo && this.originalPatInfo["PatientDiagnosis"] && this.originalPatInfo["PatientDiagnosis"].length > 0) {
            await this.changePatDiagDetails(this.originalPatInfo["PatientDiagnosis"]);
        }
        this._patientStore.storePatientInfo(Object.assign({}, this.originalPatInfo));
        this.patientInfo$ = this._patientStore.patientInfo$;

        this.verifiedDtTm =  this.originalPatInfo?.Person?.MyPrimeRxLoginDtTm ? moment.utc(this.originalPatInfo?.Person?.MyPrimeRxLoginDtTm).local().format("MM/DD/YYYY hh:mm:ss A") : '';; 
        const patEligibility = this.patientDetailsUpdates;
        this.patientDetailsUpdates = false;
        this._cdr.detectChanges();
        this.patientDetailsUpdates = patEligibility;
        this.isProgrammaticChange = true;
        if (this.originalPatInfo && this.patientInfoFG) {
            this._patUtils.patchPatientInfo(this.originalPatInfo, this.patientInfoFG);
        }
        if (frmTab) {
            await this.getPatInsurance();
        }
        if (!frmTab) {
            this.currTab = "PATIENTINFO";
        } else if (!selectTab) {
            this.selectedPatTab(this.selectedTab);
        }
        this.patientInfoFG.markAsPristine();
        this.morePatFG.markAsPristine();
        if (this.patFacilityFG) {
            this.patFacilityFG.markAsPristine();
        }
        this.patientInfoFG.valueChanges.subscribe(value => {
            if (this.patientInfoFG.dirty) {
                this.isValueChanged = true;
            } else {
                this.isValueChanged = false;
            }
        });
    }

    async changePatDiagDetails(values) {
        const patDiag = await this._patientService.getPatientDiagnosis(this.patientID).toPromise();
        this.originalPatInfo["PatientDiagnosis"] = values?.map(val => {
            let j = new PatDiagnosis();
            const x = patDiag["TempDiagnosis"]?.find(v =>
                v["DIAGCODE"] === val.DiagnosisId);
            j = Object.assign({}, val, {DiagDesc: x ? x["DIAGDESCR"] : null});
            return j;
        });
        this.patientInfoFG.markAsPristine();
        this.isProgrammaticChange = false;
    }

    getAddPatInfo() {
        if (!this.FrmErx) {
            this._patUtils.patchPatAddDefaultVal(this.patientInfoFG);
        }
        this._patientStore.storePatientInfo(this.patientInfoFG.value);
        this.patientInfo$ = this._patientStore.patientInfo$;
        this._patUtils.patchPatientInfo(this.patientInfoFG.value, this.patientInfoFG);
        this.currTab = "PATIENTINFO";
        this.patientInfoFG.markAsPristine();
    }

    async getMorePatInfo() {
        if (!this.morePatInfo) {
            const moreInfoData = await this._patientService.getMorepatientInfo(this.patientID).toPromise();
            this.originalMorePatInfo = moreInfoData ? JSON.parse(JSON.stringify(moreInfoData)) : null;
            if (this.originalMorePatInfo && !(this.originalMorePatInfo["MorePatientInfo"])) {
                const resCatID = this.patientInfoFG && this.patientInfoFG.value.Facility &&
                this.patientInfoFG.value.Facility.PatResiCatId ?
                 this.patientInfoFG.value.Facility.PatResiCatId : null;
                const ResidenceName = moreInfoData["ResidenceCatogiries"].find(v => v["Id"] ===
                resCatID);
                const DeliveryName = moreInfoData["DeliveryModes"].find(v => v["Id"] === +(this._commonServ.getSetttingValue("RxSettings", "DEF_DELIVERY_METHOD")));

                this.originalMorePatInfo["MorePatientInfo"] = {
                    PatientId: this.patientID,
                    IsDeceased: false,
                    IsPrivacyAcked: false,
                    IsFullyInsured: true,
                    DeliveryModeId: +(this._commonServ.getSetttingValue("RxSettings", "DEF_DELIVERY_METHOD")),
                    ResidenceCatId: resCatID,
                    DeliveryMode: DeliveryName && DeliveryName.Name,
                    ResidenceCatName: ResidenceName && ResidenceName.Name ? ResidenceName.Name : null
                };
            }
            this.morePatInfo = Object.assign({}, moreInfoData);
            if (this.morePatInfo && this.morePatInfo["MorePatientInfo"]) {
                this.morePatFG.patchValue(this.morePatInfo["MorePatientInfo"]);
                this.morePatFG.markAsPristine();
            }

        }
        this.currTab = "MOREPATIENTINFO";
        this.morePatFG.markAsPristine();
        this.isValueChanged = false;
        this.patientInfoFG.markAsPristine();
    }

    async getFacilityInfo() {
        if (!this.OriginalpatFacilityInfo) {
            this.OriginalpatFacilityInfo = await this._morePatSvc.getFacilityInfo(this.patientID).toPromise();
            this._patientStore.storeFacilty(Object.assign({}, this.OriginalpatFacilityInfo));
            this.facilityInfo$ = this._patientStore.patFacility$;
            this.patFacilityInfo = Object.assign({}, this.OriginalpatFacilityInfo);
            const facilitiesFromApi = this.extractFacilityRows(this.OriginalpatFacilityInfo);

            const facilitiesFromApi2 = facilitiesFromApi && facilitiesFromApi.length > 0 ? facilitiesFromApi.map(fac => {
                const formattedFac = Object.assign({}, fac);
                if (formattedFac && formattedFac["AdmitDt"]) {
                    formattedFac["AdmitDt"] = moment.utc(formattedFac["AdmitDt"]).local().format("MM/DD/YYYY");
                }
                if (formattedFac && formattedFac["DischargeDt"]) {
                    formattedFac["DischargeDt"] = moment.utc(formattedFac["DischargeDt"]).local().format("MM/DD/YYYY");
                }
                return formattedFac;
            }) : [];

            this.patFacilityFGs = facilitiesFromApi2.map(fac => {
                const fg = this._fb.group(new PatFacility());
                fg.patchValue(fac);
                fg.markAsPristine();
                return fg;
            });

            this.patFacilityFG = this.patFacilityFGs[0] || null;
            this.originalAdmitDt = this.patFacilityFG && this.patFacilityFG.value ? this.patFacilityFG.value["AdmitDt"] : null;

            this.patFacilityInfo["Facilities"] = this.patFacilityFGs.map(fg => Object.assign({}, fg.value));
            this.patFacilityInfo["PatFacility"] = this.patFacilityFGs[0] ? Object.assign({}, this.patFacilityFGs[0].value) : null;
        }
        this.currTab = "FACILITYINFO";
        this.patFacilityFGs.forEach(fg => fg.markAsPristine());
        if (this.patFacilityFG) {
            this.patFacilityFG.markAsPristine();
        }
        this.isValueChanged = false;
    }

    async reloadAfterFacilitySave() {
        this.OriginalpatFacilityInfo = null;
        this.patFacilityInfo = null;
        await this.getFacilityInfo();
    }

    private createDefaultFacilityFG(): FormGroup {
        const fg = this._fb.group(new PatFacility());
        fg.patchValue({
            Id: 0,
            PatientId: this.patientID,
            IsActive: true,
            IsDischarged: false,
            IsCycleFillAllowed: true,
            IsUnitDoseAllowed: false,
            IsPrintMedSheet: false,
            FacLocId: 0,
            FacStationId: 0
        });
        return fg;
    }

    private buildFacilityPayload(facilities: any[], selectedIndex: number) {
        const selectedFacility = { ...facilities[selectedIndex] };
        const payload = { ...(this.patFacilityInfo || {}), Facilities: facilities, PatFacility: selectedFacility };
        const payloadForApi = { ...payload, PatFacility: [{ ...selectedFacility }] };
        return payloadForApi;
    }

    createAdmissionRow() {
        const hasActiveRecord = this.patFacilityFGs.some(fg => !fg.value["IsDischarged"] && !fg.value["Id"]);
        if (hasActiveRecord) {
            this._alrtServ.error("Please save or cancel the current admission row before creating a new one.");
            return;
        }

        const newFacility = this.createDefaultFacilityFG();
        newFacility.markAsDirty();

        this.patFacilityFGs = [newFacility].concat(this.patFacilityFGs || []);
        this.patFacilityFG = this.patFacilityFGs[0];

        setTimeout(() => {
            if (this.facilityInfoComp) {
                this.facilityInfoComp.openRow(0);
            }
        }, 0);
    }

    cancelNewFacilityRow(event: { index: number }) {
        const index = event.index;
        if (index < 0 || index >= this.patFacilityFGs.length) {
            return;
        }
        const row = this.patFacilityFGs[index];
        const id = row && row.value ? row.value["Id"] : null;
        if (id && +id > 0) {
            return;
        }

        this.patFacilityFGs.splice(index, 1);
        this.patFacilityFG = this.patFacilityFGs[0] || null;
    }

    async deleteFacilityRow(event: { index: number }) {
        const index = event.index;
        const row = this.patFacilityFGs[index];
        if (!row) {
            return;
        }

        const id = row.value["Id"];
        if (!id || +id === 0) {
            this.cancelNewFacilityRow({ index });
            return;
        }

        row.patchValue({ IsActive: false });
        row.markAsDirty();

        const facilities = this.patFacilityFGs.map(fg => ({ ...fg.value }));
        const payloadForApi = this.buildFacilityPayload(facilities, index);

        try {
            const response = await this._morePatSvc.updateFacilityInfo(payloadForApi).toPromise();
            if (!response) {
                this._alrtServ.unsuccess("Unable to delete facility.");
            }
            else {
                await this.reloadAfterFacilitySave();
                this._alrtServ.success("Facility deleted successfully.");
            }
        } catch (e) {
            this._alrtServ.unsuccess("Unable to delete facility.");
        }
    }

    private toMomentDate(dateValue: any) {
        if (!dateValue) {
            return null;
        }
        if (moment.isMoment(dateValue)) {
            return dateValue;
        }
        const strictDate = moment(dateValue, "MM/DD/YYYY", true);
        if (strictDate.isValid()) {
            return strictDate;
        }
        const relaxedDate = moment(dateValue);
        return relaxedDate.isValid() ? relaxedDate : null;
    }

    private getFirstOverlappingFacilityRange(targetIndex: number) {
        const target = this.patFacilityFGs[targetIndex];
        if (!target) {
            return null;
        }

        const targetStart = this.toMomentDate(target.value["AdmitDt"]);
        if (!targetStart) {
            return null;
        }
        const targetEnd = this.toMomentDate(target.value["DischargeDt"]) || FAR_FUTURE_DATE;

        for (let i = 0; i < this.patFacilityFGs.length; i++) {
            if (i === targetIndex) {
                continue;
            }
            const row = this.patFacilityFGs[i];
            if (!row) {
                continue;
            }
            const rowStart = this.toMomentDate(row.value["AdmitDt"]);
            if (!rowStart) {
                continue;
            }
            const rowDischarge = this.toMomentDate(row.value["DischargeDt"]);
            const rowEnd = rowDischarge || FAR_FUTURE_DATE;

            const overlaps = targetStart.isSameOrBefore(rowEnd, "day") && rowStart.isSameOrBefore(targetEnd, "day");
            if (overlaps) {
                return {
                    index: i,
                    start: rowStart,
                    end: rowEnd,
                    hasDischarge: !!rowDischarge
                };
            }
        }

        return null;
    }

    private getActiveAdmissionRecord(excludeIndex: number) {
        let activeRecord: { index: number; admitDate: any } = null;
        for (let i = 0; i < this.patFacilityFGs.length; i++) {
            if (i === excludeIndex) {
                continue;
            }
            const row = this.patFacilityFGs[i];
            if (!row) {
                continue;
            }
            if (row.value["IsDischarged"]) {
                continue;
            }
            const admitDate = this.toMomentDate(row.value["AdmitDt"]);
            if (!admitDate) {
                continue;
            }
            if (!activeRecord || admitDate.isAfter(activeRecord.admitDate, "day")) {
                activeRecord = { index: i, admitDate };
            }
        }
        return activeRecord;
    }

    private getLatestDischargedBoundary(excludeIndex: number) {
        let latestDischarge = null;
        for (let i = 0; i < this.patFacilityFGs.length; i++) {
            if (i === excludeIndex) {
                continue;
            }
            const row = this.patFacilityFGs[i];
            if (!row) {
                continue;
            }
            const dischargeDate = this.toMomentDate(row.value["DischargeDt"]);
            if (!dischargeDate) {
                continue;
            }
            if (!latestDischarge || dischargeDate.isAfter(latestDischarge, "day")) {
                latestDischarge = dischargeDate;
            }
        }
        return latestDischarge;
    }

    private formatDateForError(dateValue: any) {
        return dateValue ? moment(dateValue).format("MM/DD/YYYY") : "--";
    }

    private isNewFacilityRow(index: number) {
        const row = this.patFacilityFGs[index];
        const id = row && row.value ? row.value["Id"] : null;
        return !id || +id === 0;
    }

    private validateFacilityRow(index: number) {
        const row = this.patFacilityFGs[index];
        if (!row) {
            this._alrtServ.error("Invalid facility row.");
            return false;
        }

        if (!row.value["FacilityId"]) {
            const ctrl = row.controls["FacilityId"];
            ctrl.setErrors({ ...(ctrl.errors || {}), required: true });
            ctrl.markAsTouched();
            if (this.facilityInfoComp) {
                this.facilityInfoComp.focusElement("Facility" + index);
            }
            this._alrtServ.error("Facility code is required.");
            return false;
        }

        if (!row.value["AdmitDt"]) {
            const ctrl = row.controls["AdmitDt"];
            ctrl.setErrors({ ...(ctrl.errors || {}), required: true });
            ctrl.markAsTouched();
            if (this.facilityInfoComp) {
                this.facilityInfoComp.focusElement("AdmitDtID" + index);
            }
            this._alrtServ.error("Admit date is required.");
            return false;
        }

        const admitDate = this.toMomentDate(row.value["AdmitDt"]);
        const dischargeDate = this.toMomentDate(row.value["DischargeDt"]);
        if (admitDate && dischargeDate && dischargeDate.isBefore(admitDate, "day")) {
            const ctrl = row.controls["DischargeDt"];
            ctrl.setErrors({ ...(ctrl.errors || {}), minDate: true });
            ctrl.markAsTouched();
            if (this.facilityInfoComp) {
                this.facilityInfoComp.focusElement("DischargeDtID" + index);
            }
            this._alrtServ.error("Discharge date cannot be less than admit date.");
            return false;
        }

        const isNewRow = this.isNewFacilityRow(index);
        const activeAdmission = this.getActiveAdmissionRecord(index);
        const latestDischargedBoundary = this.getLatestDischargedBoundary(index);

        if (isNewRow) {
            if (activeAdmission) {
                if (!dischargeDate) {
                    const ctrl = row.controls["DischargeDt"];
                    ctrl.setErrors({ ...(ctrl.errors || {}), required: true });
                    ctrl.markAsTouched();
                    if (this.facilityInfoComp) {
                        this.facilityInfoComp.focusElement("DischargeDtID" + index);
                    }
                    this._alrtServ.error("Discharge date is required when adding a historical record while an active admission exists.");
                    return false;
                }

                if (admitDate && admitDate.isAfter(activeAdmission.admitDate, "day")) {
                    this._alrtServ.error("Admit date must be on or before active admission date " + this.formatDateForError(activeAdmission.admitDate) + ".");
                    return false;
                }
            } else if (!dischargeDate && latestDischargedBoundary && admitDate && !admitDate.isAfter(latestDischargedBoundary, "day")) {
                this._alrtServ.error("Admit date must be greater than latest discharged date " + this.formatDateForError(latestDischargedBoundary) + " when discharge date is blank.");
                return false;
            }
        }

        const overlap = this.getFirstOverlappingFacilityRange(index);
        if (overlap) {
            const overlapStart = this.formatDateForError(overlap.start);
            const overlapEnd = overlap.hasDischarge ? this.formatDateForError(overlap.end) : "Open";
            this._alrtServ.error("Admit/Discharge dates overlap with existing record (" + overlapStart + " - " + overlapEnd + ").");
            return false;
        }

        const activeCount = this.patFacilityFGs.filter(fg => !fg.value["IsDischarged"] && !this.toMomentDate(fg.value["DischargeDt"])).length;
        if (activeCount > 1) {
            this._alrtServ.error("Only one active facility record is allowed.");
            return false;
        }

        if (row.value["IsDischarged"] && !row.value["DischargeDt"]) {
            const ctrl = row.controls["DischargeDt"];
            ctrl.setErrors({ ...(ctrl.errors || {}), required: true });
            ctrl.markAsTouched();
            if (this.facilityInfoComp) {
                this.facilityInfoComp.focusElement("DischargeDtID" + index);
            }
            this._alrtServ.error("Discharge date is required to discharge a record.");
            return false;
        }

        return true;
    }

    async saveFacilityRow(event: { index: number }) {
        const index = event.index;
        const facilityFG = this.patFacilityFGs[index];
        if (!facilityFG) {
            return;
        }

        if (!this.validateFacilityRow(index)) {
            if (this.facilityInfoComp) {
                this.facilityInfoComp.setSavingRow(index, false);
            }
            return;
        }

        const facilities = this.patFacilityFGs.map(fg => ({ ...fg.value }));
        if (!facilities[index]) {
            return;
        }

        const dischargeDate = this.toMomentDate(facilities[index]["DischargeDt"]);
        if (!dischargeDate) {
            facilities[index]["IsDischarged"] = false;
        } else {
            facilities[index]["IsDischarged"] = dischargeDate.isSameOrBefore(moment(), "day");
        }

        try {
            const payloadForApi = this.buildFacilityPayload(facilities, index);
            const response = await this._morePatSvc.updateFacilityInfo(payloadForApi).toPromise();
            if (!response) {
                this._alrtServ.unsuccess("Unable to save facility info.");
            }
            else{
                facilityFG.markAsPristine();
                await this.reloadAfterFacilitySave();
                this._alrtServ.success("Record updated successfully.");
            }
        } catch (e) {
            this._alrtServ.unsuccess("Unable to save facility info.");
        } finally {
            if (this.facilityInfoComp) {
                this.facilityInfoComp.setSavingRow(index, false);
            }
        }
    }

    selectedPatTab(tabName: string) {
        if (tabName === "Patient3") {
            this.getMorePatInfo();
        } else if (tabName === "Patient4") {
            this.getFacilityInfo();
        } else {
            this.currTab = this.tabEnum[tabName];
            this.editInsuranceData = null;
        }
        this.isNavigateFromPatientInfoTab = false;

    }

    closeModal(result) {
        this.ClosePatientModal.emit(result);
        this.patientInfoFG.reset();
    }

    getpatientInsuList() {
        this._patUtils.getPatientInsurances(this.patientID);
    }

    addtnlInsurncTab(event) {
        this.editInsuranceData = event;
        this.currTab = "ADDITIONALINSURANCES";
    }

    savePreferred(value) {
        this.preferredContact = value;
    }

    addPatientFrmTab(nextId) {
        this.selectedTab = nextId;
        this.addFrmTab = true;
        this.addOrUpdatePatientInfo(true);
    }

    resetCurrTab() {
        this.selectedTab = null;
        this.addFrmTab = false;
        this.resetToFirst = false;
        setTimeout(() => {
            this.resetToFirst = true;
        }, 100);
    }

    addOrUpdatePatientInfo(frmTab?: any) {
        const patDatesFG = this._fb.group({
            BirthDt: this.Person.controls["BirthDt"].value,
            ExpiryDt: this.InsuCards.controls["ExpiryDt"].value,
            PrivacyAckDt: this.morePatFG.controls["PrivacyAckDt"].value,
            AdmitDt: this.patFacilityFGs && this.patFacilityFGs.length > 0 ? this.patFacilityFGs[0].controls["AdmitDt"].value : null,
            PolicyNum: this.InsuCards.controls["PolicyNum"].value,
            DriverLicExpDt : this.morePatFG.controls["DriverLicExpDt"].value
        });
        var dateChecks = [{
            control: "BirthDt",
            minDate: "",
            maxDate: this.maxDate,
            formGroup : patDatesFG,
            isRequired: true,
            fieldTab : "PATIENTINFO",
            id: "patDOB"
        },
        {
            control: "ExpiryDt",
            minDate: this.minDate,
            maxDate: "",
            formGroup : patDatesFG,
            isRequired: (+this.InsuCards.controls["submissionType"].value === 0) ? false : true,
            fieldTab : "PATIENTINFO",
            id: "primInsCardExp"
        },
        {
            control: "PrivacyAckDt",
            minDate: "",
            maxDate: this.maxDate,
            formGroup : patDatesFG,
            isRequired: this.morePatFG.value['IsPrivacyAcked']? true : false,
            fieldTab : "MOREPATIENTINFO",
            id: "PrivacyAckDtID"
        }, {
            control: "AdmitDt",
            minDate: "",
            maxDate: this.maxDate,
            formGroup : patDatesFG,
            isRequired: false,
            fieldTab : "FACILITYINFO",
            id: "AdmitDtID"
        },
        {
            control: "DriverLicExpDt",
            minDate: this.minDate,
            maxDate: "",
            formGroup : patDatesFG,
            isRequired: this.morePatFG.value['DriveLicenseNum']? true : false,
            fieldTab : "MOREPATIENTINFO",
            id: "DriverLicExpDt"
        }
     ];
       /* Sentry.captureException([
            // {name: patDatesFG.value},
            {name:  this.patientInfoFG.value}
        ]);*/
         const datecCheckFields: any = this._dateChecks.checkDateValidationAtTimeofSaveAllFormGroups(dateChecks);
         if (!this.patientInfoFG.valid || !this.morePatFG.valid) {
            this.formGroupInvalid = true;
            this.Phones = this.patientInfoFG.controls["Phones"];
        if(this.Phones && this.Phones.controls.length && (this.Phones.controls[0].value.PhoneCatId == 3) && (this.Phones.controls[1].value.PhoneCatId == 2)){
            const detailsOfPhones = this.Phones.controls[0];
            this.Phones.controls[0] = this.Phones.controls[1];
            this.Phones.controls[1] = detailsOfPhones;
        }
           if (datecCheckFields) {
                this.currTab = datecCheckFields["fieldTab"];
                // this._cdr.detectChanges();
                this._cdr.detectChanges();
               setTimeout(() => {
                   const el = document.getElementById(datecCheckFields["id"]);
                   if (el) (el as HTMLElement).focus();
                   this.focusField = this.patientInfoFG.controls['Person'].value['LastName'] ? datecCheckFields["id"] : "PatLastName";
               }, 0);
            return;
           }
        } else {
            if (!this.patientInfoFG.valid|| !(this.patientInfoFG.value["InsuCarrier"]["insutypeName"] && this.patientInfoFG.value["InsuCarrier"]["insuranceIdName"])) {
                const Id =  document.getElementById("insutype");
                  if(Id){
                    Id.focus();
                }
                this.formGroupInvalid = true;
                this._cnpFG.validateAllFormFields(this.patientInfoFG);
                this.resetCurrTab();
                setTimeout(() => {
                    if (document.querySelector(".ng-invalid")) {
                        const element: any = document.querySelector(".ng-invalid");
                        (<HTMLInputElement>element).focus();
                    }
                }, 500);
                return;
            }
            this.formGroupInvalid = false;
            if (frmTab) {
                this._modalSvc.open(this.warning, { centered: true, backdrop: false, windowClass: "large--content patient-info-warning" });
            } else {
                this.checkndAddorUpdatePatient(this.patientID ? "UPDATE" : "ADD");
            }
        }
        this.patientInfoFG.markAsPristine();
        this.isValueChanged = false;
    }
    openDiagnosis(event) {
        this.openModal = event;
    }

    async checkndAddorUpdatePatient(mode: string) {
        const item = this.isDataAddedorUpdated;
        if (this.currTab === "EXTERNALHISTORY" && this.patExternHistData && (!item?.['Drug Name'] || !item?.['Fill Date'])) {
            this._alrtServ.error(!item?.['Drug Name'] ? 'Please select Drug' : !item?.['Fill Date'] ? 'Please select Fill Date' : 'Please add required fields');
            return;
        }
        const canProceed = await this.saveExternHist();
        if (!canProceed) {
            return; 
        }
        let isExist = null;
        this._patUtils.setDefndActvStatus(this.patientInfoFG, mode);
        this._patUtils.updateExtraPhones(this.patientInfoFG, this.preferredContact);
        let forceAllegval = +this._commonServ.getSetttingValue('PatientSettings','FORCE_ALLERGY_SELECTION');
        if(forceAllegval && !this.patientInfoFG.value["PatAllergies"]?.length && !this.patientInfoFG.value["Drugs"]?.length && !this.patientInfoFG.value["OtherAllergies"]?.length) {
            this._modalSvc.open(this.PATALGER, { centered: true, backdrop: false, windowClass: "large--content patient-allergy-miss-popup"});
        } else {
        if ((mode === "UPDATE") && !(this.originalPatInfo && this.originalPatInfo.InsuCards &&
            (this.originalPatInfo.InsuCards.PolicyNum == this.patientInfoFG.value["InsuCards"]["PolicyNum"]) &&
            this.originalPatInfo.Insurances.InsurerId == this.patientInfoFG.value["Insurances"]["InsurerId"])) {
            isExist = await this._commonServ.checkIfPolicyNoExists(this.patientInfoFG.value["InsuCards"]["PolicyNum"],
                this.patientInfoFG.value["Insurances"]["InsurerId"], this.patientInfoFG.value["InsuCards"]["Id"]).toPromise();
        } else if (mode === "ADD") {
            isExist = await this._commonServ.checkIfPolicyNoExists(this.patientInfoFG.value["InsuCards"]["PolicyNum"],
                this.patientInfoFG.value["Insurances"]["InsurerId"], this.patientInfoFG.value["InsuCards"]["Id"]).toPromise();
        }
        this.patientInfoFG.controls["Insurances"].patchValue({
            InsuGrpId: this.patientInfoFG.value["Insurances"]["InsuGrpId"] === 0 ? null
            : this.patientInfoFG.value["Insurances"]["InsuGrpId"]
        });
        if (mode === "UPDATE") {
            this.originalPatInfo = await this._patientService.getEditPatientInformation(this.patientID).toPromise();
            const newPatInfo = this.patientInfoFG.getRawValue();
            this.patientInfoFG.controls["Emails"].patchValue({
                xeMail: this.patientInfoFG.value["Emails"]["xeMail"] === null ? '' : this.patientInfoFG.value["Emails"]["xeMail"]
            });
            this.patientInfoFG.controls["OldInsuCardObject"].patchValue(this.originalPatInfo?.InsuCards);
             this.verifiedDtTm =  this.originalPatInfo?.Person?.MyPrimeRxLoginDtTm ? moment.utc(this.originalPatInfo?.Person?.MyPrimeRxLoginDtTm).local().format("MM/DD/YYYY hh:mm:ss A") : '';
            // this.resp1 = await this._patientService.updatePatientInfo(this.patientInfoFG.getRawValue()).toPromise();
            // this.afterUpdatePatient(this.resp1);
            const tabsList = ["MOREPATIENTINFO", "FACILITYINFO", "DIAGNOSISDETAILS", "NOTESLOG", "DOCUMENTS", "CLINICALINFO", "CUSTOMCATEGORY", "LIFESTYLECONCEPT"];
            
            if (!(tabsList.includes(this.currTab))) {
              const DateTime = moment.utc(this.patientInfoFG.controls["PatientMessageSettings"].value["SubscriptionResponseDtTm"]).local().format("MM/DD/YYYY HH:mm:ss");
              if(this.originalPatInfo?.PatientMessageSettings?.SubscriptionResponseDtTm === this.patientInfoFG?.controls["PatientMessageSettings"]?.value["SubscriptionResponseDtTm"]){
                this.patientInfoFG.get("PatientMessageSettings")?.get("SubscriptionResponseDtTm")?.patchValue(DateTime)
              }
                this.resp1 = await this._patientService.updatePatientInfo(this.patientInfoFG.getRawValue()).toPromise();
                this.afterUpdatePatient(this.resp1);
            } else {
                await this.updateMorePatAndFacInfo();
                const patOldNewData = [this.originalPatInfo, this.patientInfoFG.getRawValue()];
                this.closeModal({ Type: "Update", PatientId: this.patientID, "PatOldNewData": patOldNewData});
            }
        } else {            
            const resp = await this._patientService.addPatientInfo(this.patientInfoFG.getRawValue()).toPromise();
            this.afterAddPatient(resp);
            if (this._commonServ.overridePrivNotes$["source"]["value"] && this._commonServ.overridePrivNotes$["source"]["value"].frm == 'Patient') {
                this._notesLogSvc.addNotesLog('Patient',resp, {Note: [this._commonServ.overridePrivNotes$["source"]["value"].Note], NoteCat : null}).subscribe(resp => {
                    if (resp) 
                        this._commonServ.storeOverridePrivNotes(null);
                })
            }
            if (this.FrmErx && this.erxData && this.erxData.Species === "02") {
                this.morePatFG.patchValue({
                    PatientId: resp,
                    SpeciesCdId: +this.erxData.Species,
                    PetOwnerLastName: this.erxData.PerOwnerLastName,
                    PetOwnerFirstName: this.erxData.PetOwnerFirstName,
                });
                const moreInfoData = await this._patientService.getMorepatientInfo(resp).toPromise();
                this.morePatInfo = Object.assign({}, moreInfoData);
                this.morePatInfo["MorePatientInfo"] = this.morePatFG.value;
                this._morePatSvc.updateMorePatientInfo(this.morePatInfo).toPromise();
            }
        }
      }
      this.patientInfoFG.markAsPristine();
      if (this.patFacilityFG) {
          this.patFacilityFG.markAsPristine();
      }
      this.isValueChanged = false;
    }

    addorUpdateExternalHist(event){
        this.isDataAddedorUpdated = event;
        this.patExternHistData = event;
    }

    dataToSave(event){
        this.patExternHistData = event;
    }

    async saveExternHist(): Promise<boolean> {
        const item = this.patExternHistData;
        if(item) {
            return new Promise<boolean>((resolve) => {
                this._patientService.getPatientExternalHistory(this.patientID).pipe(takeUntil(this.unsubscribe$)).subscribe((resp) => {
                    const externalHistory = resp?.externalHistory || [];
                    // Check for duplicate Rx# and Source Pharmacy combination
                    var isDuplicate = externalHistory.some((existingItem: any) => {
                        // Skip same record in edit mode
                        if (!item["newRecord"] && existingItem.id && item.Id && existingItem.id === item.Id) {
                            return false;
                        }

                        if (!item["Rx#"] || !item["Source Pharmacy"]) {
                            return false;
                        }

                        return (
                            existingItem.prescNum?.toString().trim() === item["Rx#"].toString().trim() &&
                            existingItem.sourcePharmacyName?.toString().trim() === item["Source Pharmacy"].toString().trim()
                        );
                    });

                    if (isDuplicate) {
                        this._alrtServ.error(MsgConfig.Duplicate_ExternalHistory);
                        resolve(false); 
                        return;
                    }

                    const payload = {
                        id: item.Id,
                        patientId: this.patientID,
                        prescNum: item["Rx#"],
                        drugName: item["Drug Name"],
                        ndc: item["drugNdc"],
                        refillsLeft: item["Refills Left"],
                        rxExpirationDate: item["Expiration Date"] ? moment(item["Expiration Date"]).format(MsgConfig.DATE_FORMAT_WITH_EIPHEN) : null,
                        rxOrderedDate: item["Ordered Date"] ? moment(item["Ordered Date"]).format(MsgConfig.DATE_FORMAT_WITH_EIPHEN) : null,
                        rxFilledDate: item["Fill Date"] ? moment(item["Fill Date"]).format(MsgConfig.DATE_FORMAT_WITH_EIPHEN) : null,
                        supplyDays: item["Days Supply"] ? item["Days Supply"] : null,
                        dispQty: item["Qty Disp"] ? item["Qty Disp"] : null,
                        sourcePharmacyName: item["Source Pharmacy"],
                        sourcePharmacyNPI: item["NPINum"],
                        notes: item["Notes"],
                        drugId: item["drugId"]
                    }; 
                    if(item["newRecord"]){
                        this._patientService.addPatientExternalHistory(payload).pipe(takeUntil(this.unsubscribe$)).subscribe((resp)=>{
                            if(resp){
                                this.patExternHistData = null;
                                this.isDataAddedorUpdated = null;
                                resolve(true); 
                            } else {
                                resolve(false);
                            }
                        });
                    } else{
                        this._patientService.updatePatientExternalHistory(payload).pipe(takeUntil(this.unsubscribe$)).subscribe((res)=>{
                            if(res){
                                this.patExternHistData = null;
                                this.isDataAddedorUpdated = null;
                                resolve(true); 
                            } else {
                                resolve(false);
                            }
                        });
                    }
                });
            });
        }
        return true; 
    }

    resetPolicyNumber() {
        this.resetCurrTab();
        const insuCardsFG: any = this.patientInfoFG.controls["InsuCards"];
        insuCardsFG.controls["PolicyNum"].setValue(null);
        setTimeout(() => {
            if (document.getElementById("primInsID")) {
                document.getElementById("primInsID").focus();
            }
        }, 500);
    }

    async afterUpdatePatient(response) {
        if (response > 0) {
            const systemData = this.systemData$["source"]["value"]; // ActiveStatusId, GenderId,  PatSettings
            const PatStatus = [{'Id': 1, 'Name': true}, {'Id': 2, 'Name': false}];
            const dropdownsData = {"Gender": systemData.Gender, "PatStatus": PatStatus}
            const prescDataModel = new PatAuditLog().patAuditModel;
            this._auditUtils.saveAuditChange(
                this.originalPatInfo,
                this.patientInfoFG.getRawValue(),
                (this.currTab === "MESSAGE" ? "MessagingInfo" : "EditPatient"),
                "Patient",
                this.patientID,
                prescDataModel,
                false,
                dropdownsData
            );
            this._alrtServ.success(MsgConfig.UPDATE_SUCCESS);
            await this.updateMorePatAndFacInfo();
            const patOldNewData = [this.originalPatInfo, this.patientInfoFG.getRawValue()];
            this.closeModal({ Type: "Update", PatientId: this.patientID, "PatOldNewData": patOldNewData});
        }
    }
    async updateMorePatAndFacInfo() {
        const updateSvc = [];
        const updateOrder = [];
        if (this.morePatFG.dirty) {
            this.morePatInfo["MorePatientInfo"] = this.morePatFG.value;
            updateSvc.push(this._morePatSvc.updateMorePatientInfo(this.morePatInfo));
            updateOrder.push("MorePat");
        }
        const shouldUpdateFacilities = this.patFacilityFGs && this.patFacilityFGs.length > 0 && this.patFacilityFGs.some(fg => fg.dirty || fg.value["AdmitDt"]);
        if (shouldUpdateFacilities) {
            const invalidRowIndex = this.patFacilityFGs.findIndex((_, i) => !this.validateFacilityRow(i));
            if (invalidRowIndex > -1) {
                this.currTab = "FACILITYINFO";
                return;
            }
            const normalizedFacilities = this.patFacilityFGs.map(fg => {
                fg.controls["FacLocId"].patchValue(fg.value["FacLocId"]
                && fg.value["FacLocId"] !== 0 ? fg.value["FacLocId"] : null);
                fg.controls["FacStationId"].patchValue(fg.value["FacStationId"]
                && fg.value["FacStationId"] !== 0 ? fg.value["FacStationId"] : null);
                return Object.assign({}, fg.value);
            });
            this.patFacilityInfo["Facilities"] = normalizedFacilities;
            this.patFacilityInfo["PatFacility"] = normalizedFacilities && normalizedFacilities.length > 0 ? normalizedFacilities[0] : null;
            updateSvc.push(this._morePatSvc.updateFacilityInfo(this.patFacilityInfo));
            updateOrder.push("Facility");
        }
        let response = null;
        if (updateSvc && updateSvc.length > 0) {
            response = await forkJoin(updateSvc).toPromise();
            await this.auditForMorePatAndFacility(updateOrder);
        }
        this.patientInfoFG.markAsPristine();
        this.isValueChanged = false;
    }

    auditForMorePatAndFacility(data) {
        data.map(val => {
            if (val === "Facility") {
                const facilityPatModel = new PatAuditLog().facilityPatModel;
                this._auditUtils.saveAuditChange(
                    this.OriginalpatFacilityInfo["Facilities"] || (this.OriginalpatFacilityInfo["PatFacility"] ? [this.OriginalpatFacilityInfo["PatFacility"]] : []),
                    this.patFacilityInfo["Facilities"] || (this.patFacilityInfo["PatFacility"] ? [this.patFacilityInfo["PatFacility"]] : []),
                    "FacilityInfo",
                    "Patient",
                    this.patientID,
                    facilityPatModel
                );
            } else if (val === "MorePat") {
                const morePatModel = new PatAuditLog().morePatInfoModel;
                this._auditUtils.saveAuditChange(
                    this.originalMorePatInfo["MorePatientInfo"],
                    this.morePatInfo["MorePatientInfo"],
                    "MorePatientInfo",
                    "Patient",
                    this.patientID,
                    morePatModel,
                    null,
                    null,
                    null,
                    null,
                    this.morePatInfo
                );
            }
        });
    }

    async afterAddPatient(response) {
        if (response > 0) {
            const systemData = this.systemData$["source"]["value"]; // ActiveStatusId, GenderId,  PatSettings
            const PatStatus = [{'Id': 1, 'Name': true}, {'Id': 2, 'Name': false}];
            const dropdownsData = {"Gender": systemData.Gender, "PatStatus": PatStatus};
            const prescDataModel = new PatAuditLog().patAuditModel;
            this._auditUtils.saveAuditOnAdd(
                this.patientInfoFG.getRawValue(),
                "AddPatient",
                "Patient",
                response,
                prescDataModel,
                dropdownsData
            );
            this._alrtServ.success(MsgConfig.SAVE_SUCCESS);
            if (this.addFrmTab || this.addFromEligibility) {
                this.addToEditPat = true;
                this.patientID = response;
                await this.getPatinetInfo(this.addFrmTab);
                this.addFrmTab = false;
                if (this.addFromEligibility) {
                    this.openEligblPopUpModal();
                }
                this.addFromEligibility = false;
            } else {
                this.addToEditPat = false;
                this.closeModal({ Type: "Add", PatientId: response });
            }
        }
    }
    onCancel(value) {
        this._commonServ.storeOverridePrivNotes(null);
        if(this.isValueChanged){
            this.popUpType = value;
            if (value && value !== "cancel") {
                this.closeModal({ Type: this.addToEditPat ? "Update" : "Cancel", PatientId: this.patientID });
            }
        } else{
            this.closeModal({ Type: this.addToEditPat ? "Update" : "Cancel", PatientId: this.patientID });
        }
    }

    checkAndOpenEligibility() {
        if (this.patientID) {
            this.openEligblPopUpModal();
        } else {
            this.addFromEligibility = true;
            this.addOrUpdatePatientInfo();
        }
    }

    openEligblPopUpModal() {
        const PersonFg: any = this.patientInfoFG && this.patientInfoFG.controls ? this.patientInfoFG.controls["Person"] : null;
        if (PersonFg && PersonFg.controls && PersonFg.controls["BirthDt"].value && !this._cmnutil.checkDateTimeFields(PersonFg.controls["BirthDt"].value)) {
            this._alrtServ.error("Please enter Valid Date of Birth(DOB)");
        } else {
            const modalRef = this._modalSvc.open(EligibilityComponent, {
                    backdrop: false,
                    size: "lg",
                    windowClass: "modal-md modal-center-to-page scroll-popup-anywhere",
                    keyboard: false,
            });
            const PatientInfo = this.patientInfo$?.["source"]?.["value"]
            if(PersonFg?.controls?.["Id"]?.value !== PatientInfo?.Person?.Id ){
                this._patientStore.storePatientInfo(Object.assign({}, this.originalPatInfo));
            }
            modalRef.componentInstance.PatientInfoFG = this.patientInfoFG;
            modalRef.componentInstance.SystemData = this.systemData$?.["source"]?.["value"];
            modalRef.componentInstance.PatientInfo = this.patientInfo$?.["source"]?.["value"];
            modalRef.componentInstance.Insurances = this.insuranceData$?.["source"]?.["value"];
            modalRef.componentInstance.GetPatientInfo.pipe(takeUntil(this.unsubscribe$)).subscribe(resp => {
                this.getPatinetInfo();
            });
        }
    }
    closePopUpFor340BInsurance(event) {
        if(event) {
            this.isNavigateFromPatientInfoTab = true;
            this.currTab = "ADDITIONALINSURANCES";
        } else
        this.isNavigateFromPatientInfoTab = false;

    }
    exist340bInsurancePopupClose(event) {
        if(event) {
            this.isNavigateFromPatTabForRefresh = true;
         //   this.currTab = "ADDITIONALINSURANCES";
        } else
          this.isNavigateFromPatTabForRefresh = false;

    }
    
    ngOnDestroy(){
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        this._cmnutil.close(this.popupId);

    }
}
